import type {
	Floor,
	Location,
	Sensor,
	ShadowUpdateFloorRequest,
	ShadowUpdateZoneRequest,
	UpdateSensorRequest,
	Zone,
} from "@sitescene/types";

import { useMutation } from "@tanstack/react-query";

import type { UpdateLocationRequest } from "@/api/locations";

import { floorsApi } from "@/api/floors";
import { locationsApi } from "@/api/locations";
import { sensorsApi } from "@/api/sensors";
import { zonesApi } from "@/api/zones";

import { useInvalidateMapQueries } from "./useInvalidateMapQueries";

export const useUpdateLocation = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: ({
			body,
			locationId,
		}: {
			body: UpdateLocationRequest;
			locationId: string;
		}): Promise<Location> => locationsApi.updateLocation(locationId, body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useUpdateFloor = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: ({
			body,
			floorId,
		}: {
			body: ShadowUpdateFloorRequest;
			floorId: string;
		}): Promise<Floor> => floorsApi.updateFloor(floorId, body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useUpdateZone = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: ({
			body,
			zoneId,
		}: {
			body: ShadowUpdateZoneRequest;
			zoneId: string;
		}): Promise<Zone> => zonesApi.updateZone(zoneId, body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useUpdateSensor = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: ({
			body,
			sensorId,
		}: {
			body: UpdateSensorRequest;
			sensorId: string;
		}): Promise<Sensor> => sensorsApi.updateSensor(sensorId, body),
		onSuccess: () => {
			invalidate();
		},
	});
};
